<template>
  <div class="settings">
    <card :title="$t('common.settings')" id="configurator" v-if="canEdit || canDelete">
      <ul class="nav nav-tabs" id="myTab" role="tablist">
        <li class="nav-item t1 gruop" v-for="(group, index) in setting_groups" :key="group.uuid">
          <a
            class="nav-link"
            :class="[{ active: active_tab?.code === group.code, 'text-danger': group.is_editable === 0 }]"
            :id="group.code + '-tab'"
            data-toggle="tab"
            :href="'#' + group.code"
            role="tab"
            :aria-controls="group.code"
            :aria-selected="index === 0"
            @click="tabChanged(group)"
          >
            {{ group.name }}
          </a>
        </li>
      </ul>
      <div class="tab-content" id="myTabContent">
        <div
          class="tab-pane fade pt-1"
          :class="[{ show: active_tab?.code === group.code }, { active: active_tab?.code === group.code }]"
          v-for="group in setting_groups"
          :key="group.uuid"
          :id="group.code"
          role="tabpanel"
          :aria-labelledby="group.code + '-tab'"
        >
          <setting-group :data="group"></setting-group>
        </div>
      </div>
    </card>
    <div v-else>
      <forbidden></forbidden>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { canDelete, canEdit, permissions, permissionTypes } from "@/helpers/Permissions";
import Forbidden from "@/pages/errors/Forbidden";
import SettingGroup from "@/pages/tools/settings/partials/SettingGroup";

export default {
  name: "SettingsPage",
  data() {
    return {
      config: {
        permission: permissions.SETTINGS,
        permission_type: permissionTypes.module,
      },
      setting_groups: this.filterOutErpIntegrationGroup(this.groups ? this.groups : []),
      active_tab: undefined,
    };
  },
  components: {
    SettingGroup,
    Forbidden,
  },
  computed: {
    ...mapGetters({
      groups: "settings/settingGroups",
    }),
    canEdit() {
      return canEdit(this);
    },
    canDelete() {
      return canDelete(this);
    },
  },
  methods: {
    ...mapActions({
      getGroups: "settings/getSettingGroups",
    }),
    filterOutErpIntegrationGroup(groups) {
      if (!Array.isArray(groups)) {
        return [];
      }

      return groups.filter((group) => {
        const code = (group?.code || "").toUpperCase();
        const itemCodes = (group?.items || []).map((item) => (item?.code || "").toUpperCase());

        return code !== "ERP_INTEGRATION" && !itemCodes.includes("ERP_INTEGRATION_ENABLED") && !itemCodes.includes("ERP_NAME");
      });
    },
    tabChanged(group) {
      this.$set(this, "active_tab", group);
    },
  },
  mounted() {
    this.getGroups().then((resp) => {
      const filtered = this.filterOutErpIntegrationGroup(resp || []);
      this.$set(this, "setting_groups", filtered);

      if (filtered && filtered.length > 0) {
        this.$set(this, "active_tab", filtered[0]); //first tab activate
      }
    });
  },
  watch: {
    groups: {
      handler: function (newVal) {
        this.setting_groups = this.filterOutErpIntegrationGroup(newVal);

        if (this.active_tab && !this.setting_groups.some((group) => group.uuid === this.active_tab.uuid)) {
          this.active_tab = this.setting_groups[0] || undefined;
        }
      },
      deep: true,
    },
  },
};
</script>
